<template>
    <edit-boolean
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :readonly="readonly"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue"
        :description="descriptionValue"
        :type="typeValue || 'checkbox'"
        :hide-details="hideDetails"
        :info="info"
        :default-value="defaultValue"
        :on-text="onText"
        :on-description="onDescription"
        :off-text="offText"
        :off-description="offDescription"
        :column="column"
        :row="row"
        :prevent-set-default-value="preventSetDefaultValue"
        @input="$emit('input', $event)"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        @keyup="$emit('keyup')"
        @keydown="$emit('keydown')"
        @click="$emit('click')"
    >
        <template v-if="findSlot('description')" #description>
            <slot name="description" />
        </template>
        <template v-if="findSlot('info')" #info>
            <slot name="info" />
        </template>
    </edit-boolean>
</template>

<script>
import BaseField from './BaseField';
export default {
    name: 'Toggle',
    extends: BaseField,
    props: {
        defaultValue: {
            type: Boolean,
            default: false
        },
        onText: {
            type: String,
            default: null
        },
        onDescription: {
            type: String,
            default: null
        },
        offText: {
            type: String,
            default: null
        },
        offDescription: {
            type: String,
            default: null
        },
        column: {
            type: Boolean,
            default: false
        },
        row: {
            type: Boolean,
            default: true
        },
        requiredTrue: {
            type: Boolean,
            default: false
        },
        preventSetDefaultValue: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        rulesValue() {
            const rules = [];

            if (this.requiredTrue) {
                rules.push(() => this.getValidator('isTrue')(this.inputValue, this.labelValue));
            }

            return [...this.rules, ...this.rulesArray, ...rules];
        }
    }
};
</script>
